// extracted by mini-css-extract-plugin
module.exports = {"Add":"Add_Add__2kaEX","Step":"Add_Step__1p1h0","Head":"Add_Head__2ExcG","Submit":"Add_Submit__1JRxU"};